(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9396],{

/***/ 38191:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(46505);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);



const formatString = (value)=>{
    const formattedString = value.replace(/<br>/g, '<br><span class="mb-4 block"></span>');
    return formattedString;
};
const PrivacyPolicy = ()=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const contentTerm = {
        title: t("term_of_service.title"),
        description: [
            t("term_of_service.desc_1"),
            t("term_of_service.desc_2"),
            t("term_of_service.desc_3"),
            t("term_of_service.desc_4"),
            t("term_of_service.desc_5")
        ],
        content: [
            {
                title: t("term_of_service.path_1_title"),
                description: [
                    t("term_of_service.path_1_desc_1"),
                    t("term_of_service.path_1_desc_2"),
                    t("term_of_service.path_1_desc_3"),
                    t("term_of_service.path_1_desc_4")
                ]
            },
            {
                title: t("term_of_service.path_2_title"),
                description: [
                    t("term_of_service.path_2_desc_1"),
                    t("term_of_service.path_2_desc_2"),
                    t("term_of_service.path_2_desc_3")
                ]
            },
            {
                title: t("term_of_service.path_3_title"),
                description: [
                    t("term_of_service.path_3_desc_1"),
                    t("term_of_service.path_3_desc_2")
                ]
            },
            {
                title: t("term_of_service.path_4_title"),
                description: [
                    t("term_of_service.path_4_desc_1")
                ]
            },
            {
                title: t("term_of_service.path_5_title"),
                description: [
                    t("term_of_service.path_5_desc_1"),
                    t("term_of_service.path_5_desc_2")
                ]
            },
            {
                title: t("term_of_service.path_6_title"),
                description: [
                    t("term_of_service.path_6_desc_1")
                ]
            },
            {
                title: t("term_of_service.path_7_title"),
                description: [
                    t("term_of_service.path_7_desc_1")
                ]
            },
            {
                title: t("term_of_service.path_8_title"),
                description: [
                    t("term_of_service.path_8_desc_1")
                ]
            },
            {
                title: t("term_of_service.path_9_title"),
                description: [
                    t("term_of_service.path_9_desc")
                ]
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "text-justify mt-8 px-[20px] term-service mb-[50px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-center Nunito-700 font-extrabold mb-2",
                children: contentTerm.title
            }),
            contentTerm.description.map((text, index)=>{
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mb-2",
                    dangerouslySetInnerHTML: {
                        __html: text
                    }
                }, index);
            }),
            contentTerm.content.map((item, index)=>{
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "Nunito-700 font-extrabold mb-2",
                            children: item.title
                        }),
                        item.description.map((text, index)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mb-2",
                                dangerouslySetInnerHTML: {
                                    __html: formatString(text)
                                }
                            }, index);
                        })
                    ]
                }, index);
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .withTranslation */ .Zh)("common")(PrivacyPolicy));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2888,179], function() { return __webpack_exec__(38191); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);